/* eslint-disable class-methods-use-this */
import APIError from '../../errors/APIError';

import Package from '../../../package.json';

class HttpClient {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  get(path, options) {
    return this.makeRequest(path, {
      method: 'GET',
      headers: options?.headers,
    });
  }

  post(path, options) {
    return this.makeRequest(path, {
      method: 'POST',
      body: options?.body,
      headers: options?.headers,
    });
  }

  put(path, options) {
    return this.makeRequest(path, {
      method: 'PUT',
      body: options?.body,
      headers: options?.headers,
    });
  }

  async makeRequest(path, options) {
    const headers = new Headers();
    headers.append('Device-Type', Package.name);
    headers.append('Device-Os', 'Web');
    headers.append('Device-Version', Package.version);
    headers.append('Device-Version', process.env.REACT_APP_BASE_ROUTE);

    if (options.body) {
      headers.append('Content-Type', 'application/json');
    }

    if (options.headers) {
      Object.entries(options.headers).forEach(([name, value]) => {
        headers.append(name, value);
      });
    }

    const response = await fetch(`${this.baseUrl}${path}`, {
      method: options.method,
      body: JSON.stringify(options.body),
      headers,
    });

    let responseBody = null;
    const contentType = response.headers.get('Content-type');

    if (contentType?.includes('application/json')) {
      responseBody = await response.json();
    }

    if (response.ok) {
      return responseBody;
    }

    throw new APIError(response, responseBody);
  }

  async getDownload(path) {
    const response = await fetch(`${this.baseUrl}${path}`);
    let responseBody = null;

    responseBody = await response.blob();

    if (response.ok) {
      return this.urlPdfObject(responseBody);
    }

    throw new APIError(response, responseBody);
  }

  async postDownload(path, options, idRequisicao, tipo) {
    const headers = new Headers();
    if (options.body) {
      headers.append('Content-Type', 'application/json');
    }

    if (options?.headers) {
      Object.entries(options.headers).forEach(([name, value]) => {
        headers.append(name, value);
      });
    }

    const response = await fetch(`${this.baseUrl}${path}`, {
      method: 'POST',
      body: JSON.stringify(options.body),
      headers,
    });
    let responseBody = null;

    // const contentType = response.headers.get('Content-type');

    // if (contentType?.includes('application/pdf')) {
    // }

    // responseBody = await response.text();
    responseBody = await response.blob();

    if (response.ok) {
      if (tipo.toLowerCase() === 'pac') {
        this.download(responseBody, `Laudo_${idRequisicao}`);
        return responseBody;
      }
      return this.urlPdfObject(responseBody);
    }

    throw new APIError(response, responseBody);
  }

  download(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    // the filename you want
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  urlPdfObject(blob) {
    const url = window.URL.createObjectURL(blob);
    return url;
  }
}

export default HttpClient;
